module.exports = __webpack_public_path__ + "img/flow4.72343075.png";